import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const Wrapper = styled.div(() =>
  mq({
    display: ['block', 'block', 'flex', 'flex'],
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    backgroundColor: defaultTheme.background.white,
    padding: defaultTheme.spacing.l,
  }),
);

export const RaceProgramDetailWrapper = styled.div(() =>
  mq({
    marginRight: ['0', '0', defaultTheme.spacing.s, defaultTheme.spacing.s],
  }),
);

export const Content = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: ['column', 'column', 'row', 'row'],
    alignItems: ['flex-start', 'flex-start', 'center', 'center'],
    width: '100%',
    lineHeight: 1,
  }),
);

export const ProgramName = styled.p(() =>
  mq({
    fontSize: defaultTheme.font.size.m,
    lineHeight: defaultTheme.font.height.base,
    wordBreak: 'break-all',
    marginTop: [defaultTheme.spacing.s, defaultTheme.spacing.s, '0', '0'],
    textAlign: 'left',
  }),
);

export const SelectWrapper = styled.div(() =>
  mq({
    width: '100%',
    marginTop: defaultTheme.spacing.l,
    backgroundColor: defaultTheme.background.white,
    display: ['block', 'block', 'none', 'none'],
  }),
);

export const DailyNumList = styled.ul(() =>
  mq({
    backgroundColor: defaultTheme.background.white,
    display: ['none', 'none', 'flex', 'flex'],
    alignItems: 'center',
    flex: '1 0 auto',
  }),
);

export const DailyNum = styled.li(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
    '&:not(:last-of-type)::after': {
      content: '""',
      display: 'inline-block',
      width: '1px',
      height: '16px',
      backgroundColor: defaultTheme.border.color.mediumGray,
    },
    '&:last-of-type': {
      marginRight: '-8px',
    },
    '& > a, & > div': {
      display: 'inline-block',
      padding: `${defaultTheme.spacing.m} ${defaultTheme.spacing.l}`,
    },
    '& > a': {
      ...hoverOpacity,
    },
    '& > div': {
      opacity: defaultTheme.button.opacity.disabled,
    },
  }),
);
